import { api } from "@/api/axios.ts";
import {
  ApiFeatureSettings,
  ApiOrganizationBackgroundApplyTo,
  ApiOrganizationGeneralSettings,
  ApiOrganizationPayload,
  ApiOrganizationSettingsHomeLayout,
  ApiOrganizationSettingsHomeLayoutPayload,
  ApiOrganizationSettingsMetricCalculations,
  ApiOrganizationSettingsViewFilter,
} from "@/types/organization.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiOrganizationSettingsPreboarding } from "@/types/preboarding.types.ts";
import { ApiFeatureSettingsPayload } from "@/types/subscription.types.ts";

export const apiOrganization = {
  getSettings: async function () {
    return api.get<ApiOrganizationGeneralSettings>(`/api/v1/settings/general`);
  },
  updateSettings: async function (settings: ApiOrganizationPayload) {
    return api.put<ApiOrganizationGeneralSettings>(`/api/v1/settings/general`, settings);
  },
  setLogo: async function (fileUUID: string) {
    return api.put<ApiOrganizationGeneralSettings>(`/api/v1/settings/general/logo`, {
      file_uuid: fileUUID,
    });
  },
  deleteLogo: async function () {
    return api.delete<ApiOrganizationGeneralSettings>(`/api/v1/settings/general/logo`);
  },
  setBackground: async function (
    fileUUID: string,
    applyTo = ApiOrganizationBackgroundApplyTo.new_employees
  ) {
    return api.put<ApiOrganizationGeneralSettings>(`/api/v1/settings/general/background`, {
      file_uuid: fileUUID,
      apply_to: applyTo,
    });
  },
  deleteBackground: async function () {
    return api.delete<ApiOrganizationGeneralSettings>(`/api/v1/settings/general/background`);
  },
  getFeatures: async function () {
    return api.get<ApiFeatureSettings>(`/api/v1/settings/features`);
  },
  updateFeatures: async function (settings: ApiFeatureSettingsPayload) {
    return api.put<ApiOperationResult>(`/api/v1/settings/features`, settings);
  },
  getViewFilter: async function () {
    return api.get<ApiOrganizationSettingsViewFilter>(`/api/v1/settings/view-filter`);
  },
  updateViewFilter: async function (settings: ApiOrganizationSettingsViewFilter) {
    return api.put<ApiOrganizationSettingsViewFilter>(`/api/v1/settings/view-filter`, settings);
  },
  getMetricCalculations: async function () {
    return api.get<ApiOrganizationSettingsMetricCalculations>(
      `/api/v1/settings/metric-calculations`
    );
  },
  updateMetricCalculations: async function (settings: ApiOrganizationSettingsMetricCalculations) {
    return api.put<ApiOrganizationSettingsMetricCalculations>(
      `/api/v1/settings/metric-calculations`,
      settings
    );
  },
  getPreboardingSettings: async function () {
    return api.get<ApiOrganizationSettingsPreboarding>(`/api/v1/settings/preboarding`);
  },
  updatePreboardingSettings: async function (settings: ApiOrganizationSettingsPreboarding) {
    return api.put<ApiOrganizationSettingsPreboarding>(`/api/v1/settings/preboarding`, settings);
  },
  getHomeLayoutSettings: async function () {
    return api.get<ApiOrganizationSettingsHomeLayout>(`/api/v1/settings/home-layout`);
  },
  updateHomeLayoutSettings: async function (settings: ApiOrganizationSettingsHomeLayoutPayload) {
    return api.put<ApiOrganizationSettingsHomeLayout>(`/api/v1/settings/home-layout`, settings);
  },
};
